// extracted by mini-css-extract-plugin
export default {"container":"kBahMRhtfeNVae3fJsTd"};